<div (click)="open()" *ngIf="selectedFiltersCount === 1" class="filter-title">
  ({{ selectedFiltersCount }} {{ 'SHARED.Active_Filter' | translate }})
</div>
<div (click)="open()" *ngIf="selectedFiltersCount > 1" class="filter-title">
  ({{ selectedFiltersCount }} {{ 'SHARED.Active_Filters' | translate }})
</div>
